import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { oktaAuth } from '../utils/okta';
import { toast } from 'react-toastify';
import { API } from './api';

interface DownloadParams {
  startDate: string;
  endDate: string;
}

export const exportCsvApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: API.BaseURL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const tokens = oktaAuth.tokenManager.getTokensSync();

      if (!tokens.accessToken) return;

      headers.set('Content-Type', API.contentType);
      headers.set('Authorization', `${tokens.accessToken.tokenType} ${tokens.accessToken.accessToken}`);

      return headers;
    },

    responseHandler: async (response) => {
      if (
        response.headers.get('Content-Type')?.includes('text/csv') ||
        response.headers.get('Content-Type')?.includes('application/octet-stream')
      ) {
        return response.blob();
      }
    },
  }),
  reducerPath: 'csv',
  tagTypes: ['ReconCsvFile'],
  endpoints: (build) => ({
    downloadCSVFile: build.mutation<Blob, DownloadParams>({
      query: ({ startDate, endDate }: DownloadParams) => `denodo/export/csv?startDate=${startDate}&endDate=${endDate}`,
      transformErrorResponse: (response) => {
        toast.error(`Error exporting file. Error: ${response.status as string}`);
        return response;
      },
    }),
  }),
});
